<template>
  <div class="history-content">
    <div class="history-contain">
      <div class="title">通文服务--深耕人才服务与产教融合</div>
      <div class="message">
        聚焦人才培育深化产教融合，深耕园区运营助力产业发展
      </div>
      <div class="history-list" ref="historyList">
        <div class="list-flex" ref="historyTrack">
          <template v-for="(item, index) in timelineList">
            <div class="flex-item" v-if="index % 2 == 0" :key="index + '-even'">
              <div class="item-tip">
                <div class="round"></div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="2"
                  height="143"
                  viewBox="0 0 2 143"
                  fill="none"
                  class="svg-image"
                >
                  <path
                    d="M1 0V143"
                    stroke="url(#paint0_linear_99_1365)"
                    stroke-width="2"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_99_1365"
                      x1="1.5"
                      y1="0"
                      x2="1.5"
                      y2="143"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#1B56A9" />
                      <stop offset="0.935935" stop-color="#F9FAFB" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <div class="item-column">
                <div class="item-date">{{ item.timePoint.substr(0, 7) }}</div>
                <div class="item-message">
                  {{ item.description }}
                </div>
              </div>
            </div>
            <div class="flex-item" v-else :key="index + '-odd'"></div>
          </template>
        </div>
        <div class="list-hr" :style="{ width: lineWidth }"></div>
        <div class="list-flex">
          <template v-for="(item, index) in timelineList">
            <div
              class="flex-item flex-item-other"
              v-if="index % 2 != 0"
              :key="index + '-even'"
            >
              <div class="item-tip">
                <div class="round"></div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="2"
                  height="143"
                  viewBox="0 0 2 143"
                  fill="none"
                  class="svg-image"
                >
                  <path
                    d="M1 0V143"
                    stroke="url(#paint0_linear_99_1365)"
                    stroke-width="2"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_99_1365"
                      x1="1.5"
                      y1="0"
                      x2="1.5"
                      y2="143"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#1B56A9" />
                      <stop offset="0.935935" stop-color="#F9FAFB" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <div class="item-column">
                <div class="item-date">{{ item.timePoint.substr(0, 7) }}</div>
                <div class="item-message">
                  {{ item.description }}
                </div>
              </div>
            </div>
            <div
              class="flex-item flex-item-other"
              v-else
              :key="index + '-odd'"
            ></div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTimelineList } from '@/api/home/home'
import { mapState } from 'vuex'
export default {
  name: 'History',
  data() {
    return {
      timelineList: [], // 时间轴列表
      isDown: false,
      startX: 0,
      scrollLeft: 0,
      lineWidth: '100%'
    }
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile // 假设 isMobile 在根 state 下
    })
  },
  watch: {
    timelineList() {
      this.$nextTick(this.syncLineWidth)
    },
    isMobile() {
      this.$nextTick(this.syncLineWidth)
    }
  },
  created() {
    this.getLineList()
  },
  mounted() {
    const el = this.$refs.historyList
    el.addEventListener('mousedown', this.onMouseDown)
    el.addEventListener('mouseleave', this.onMouseLeave)
    el.addEventListener('mouseup', this.onMouseUp)
    el.addEventListener('mousemove', this.onMouseMove)
    window.addEventListener('resize', this.syncLineWidth)
    this.$nextTick(this.syncLineWidth)
  },
  beforeDestroy() {
    const el = this.$refs.historyList
    el.removeEventListener('mousedown', this.onMouseDown)
    el.removeEventListener('mouseleave', this.onMouseLeave)
    el.removeEventListener('mouseup', this.onMouseUp)
    el.removeEventListener('mousemove', this.onMouseMove)
    window.removeEventListener('resize', this.syncLineWidth)
  },
  methods: {
    getLineList() {
      getTimelineList().then((res) => {
        if (!res.data) return
        this.timelineList = res.data
      })
    },
    syncLineWidth() {
      const track = this.$refs.historyTrack
      const container = this.$refs.historyList
      if (!track || !container) {
        this.lineWidth = '100%'
        return
      }
      this.lineWidth = `${Math.max(track.scrollWidth, container.clientWidth)}px`
    },
    onMouseDown(e) {
      this.isDown = true
      this.startX = e.pageX - this.$refs.historyList.offsetLeft
      this.scrollLeft = this.$refs.historyList.scrollLeft
      this.$refs.historyList.style.cursor = 'grabbing'
    },
    onMouseLeave() {
      this.isDown = false
      this.$refs.historyList.style.cursor = 'grab'
    },
    onMouseUp() {
      this.isDown = false
      this.$refs.historyList.style.cursor = 'grab'
    },
    onMouseMove(e) {
      if (!this.isDown) return
      e.preventDefault()
      const x = e.pageX - this.$refs.historyList.offsetLeft
      const walk = (x - this.startX) * 1 // 滑动速度
      this.$refs.historyList.scrollLeft = this.scrollLeft - walk
    }
  }
}
</script>

<style scoped lang="scss">
.history-content {
  display: flex;
  flex-direction: column;
  background: #f9fafb;

  .history-contain {
    display: flex;
    flex-direction: column;
    height: 958px;
    background: url('../../../assets/images/icon-20.png') no-repeat;
    background-size: contain;
    background-position-y: bottom;
  }
  .history-list {
    display: flex;
    flex-direction: column;
    min-width: 1340px;
    width: fit-content;
    max-width: 100%;
    margin: 220px auto 0;
    overflow-y: hidden;
    overflow-x: auto;
    padding-top: 10px;
    cursor: grab;
    .list-flex {
      display: -webkit-box;
      flex-direction: row;
      gap: 20px;
      width: fit-content;
      padding: 0 60px;
      // height: 335px;
      .flex-item {
        display: flex;
        flex-direction: row;
        height: 150px;
        width: 188px;
        margin-bottom: 20px;
        // margin-right: 20px;
        .item-column {
          display: flex;
          flex-direction: column;
          flex: 1;
          margin-left: 12px;
          .item-message {
            color: #5c5c5c;
            font-size: 16px;
            font-weight: 400;
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            margin-top: 16px;
          }
          .item-date {
            display: flex;
            height: 34px;
            line-height: 34px;
            color: #1b56a9;
            font-size: 24px;
            font-weight: bold;
            margin-top: -10px;
          }
        }
        .item-tip {
          display: flex;
          flex-direction: column;
          width: 12px;
          .svg-image {
            margin: 0 auto;
          }
          .round {
            width: 12px;
            height: 12px;
            background: #1b56a9;
            border-radius: 50%;
          }
        }
      }
      .flex-item-other {
        margin-top: 20px;
      }
    }
    .list-hr {
      width: 100%;
      height: 2px;
      background: #1b56a9;
      display: -webkit-box;
    }
    /* 自定义滚动条 */
    &::-webkit-scrollbar {
      height: 12px;
      background-color: #f1f1f1;
      border-radius: 6px;
    }
    &::-webkit-scrollbar-track {
      background-color: #f1f1f1;
      border-radius: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border-radius: 6px;
      border: 3px solid #f1f1f1;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: #a1a1a1;
    }
    /* Firefox 滚动条 */
    scrollbar-width: thin;
    scrollbar-color: #c1c1c1 #f1f1f1;
  }
  .message {
    color: #5c5c5c;
    font-size: 18px;
    font-weight: 400;
    height: 28px;
    line-height: 28px;
    text-align: center;
    margin-top: 24px;
  }
  .title {
    color: #111;
    font-size: 40px;
    font-weight: 600;
    height: 90px;
    line-height: 90px;
    text-align: center;
  }
  .title-btn {
    border-radius: 9999px;
    border: 0 solid #e5e7eb;
    background: rgba(27, 86, 169, 0.1);
    width: 88px;
    height: 32px;
    line-height: 32px;
    padding: 0 16px;
    color: #1b56a9;
    font-size: 14px;
    font-weight: 500;
    margin: 64px auto 16px;
  }
}

// 手机端css
.mobile-content {
  .history-content {
    .history-contain {
      height: 500px;
      .history-list {
        width: 375px;
        margin: 50px auto 0;
        .list-flex {
          gap: 10px;
          .flex-item {
            width: 130px;
            height: 100px;
            margin-bottom: 10px;
            margin-left: 10px;
            .item-column {
              .item-message {
                font-size: 12px;
                line-height: 18px;
              }
              .item-date {
                height: 25px;
                height: 25px;
                font-size: 18px;
              }
            }
            .item-tip {
              width: 10px;
              .svg-image {
                flex: 1;
              }
              .round {
                width: 10px;
                height: 10px;
              }
            }
          }
        }
      }
      .message {
        font-size: 14px;
        line-height: 20px;
        height: auto;
        width: 345px;
        margin: 12px auto 0;
      }
      .title {
        font-size: 24px;
        line-height: 35px;
        height: auto;
        width: 345px;
        margin: 0 auto;
      }
      .title-btn {
        margin-top: 32px;
      }
    }
  }
}
</style>
